import {
  Box,
  Image,
  Heading,
  Link,
  Text,
  Flex,
  Grid,
  Tooltip,
} from "@chakra-ui/react";
import React, { useContext, useEffect } from "react";
import fashntra from "../Assets/Projects/fashntra.png";
import fitQuest from "../Assets/Projects/fitQuest.png";
import kidsland from "../Assets/Projects/kidsland.png";
import woodencrafts from "../Assets/Projects/woodencrafts.png";

import { MdOutlinePlayCircle } from "react-icons/md";
import { PiSuitcaseSimpleDuotone } from "react-icons/pi";
import { BiLogoGithub } from "react-icons/bi";
import "./Project.css";
import AOS from "aos";
import { themeContext } from "../Context";
export const Projects = () => {
  useEffect(() => {
    AOS.init({ delay: 300 });
  }, []);

  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;
  return (
    <Box
      cursor={"pointer"}
      textAlign={"center"}
      id="projects"
      // bg={"#2F2F2F"}
      boxSizing="border-box"
      color={"white"}
      overflow={"hidden"}
      paddingTop={{ base: "60px", md: "80px" }}
    >
      <Heading
        mt="40px"
        textAlign={"center"}
        className="projects"
        display={"inline-block"}
        padding="10px"
        as="h1"
        size={"2xl"}
        color={"#FCA61F"}
        data-aos="fade-right"
        fontFamily="initial"
      >
        Projects
      </Heading>

      <Grid>
        {/* <==============================Project-1=========================================> */}
        <Box
          id="project-sec"
          data-aos="fade-right"
          boxSize={"border-box"}
          borderRadius={"10px"}
          p="20px"
          w="80%"
          m="40px auto"
          // className="project-card"
          className={`project-card ${darkMode ? "" : "dark-mode"}`}
        >
          <Flex
            gap={"30px"}
            justifyContent={"space-evenly"}
            direction={{
              base: "column-reverse",
              sm: "column-reverse",
              md: "column-reverse",
              lg: "row",
              xl: "row",
              "2xl": "row",
            }}
          >
            <Box
              w={{
                base: "100%",
                sm: "100%",
                md: "100%",
                lg: "100%",
                xl: "100%",
                "2xl": "100%",
              }}
              boxSizing="border-box"
            >
              <Flex justifyContent={"space-between"}>
                <PiSuitcaseSimpleDuotone
                  style={{ color: "#FCA61F", fontSize: "35px" }}
                />
                <Box>
                  <Flex gap={5}>
                    <Tooltip label="Live">
                      <Link
                        href="https://saregama.vercel.app/"
                        className="project-deployed-link"
                          target="_blank"
  rel="noopener noreferrer"
  isExternal
                      >
                        {" "}
                        <MdOutlinePlayCircle className="icon" />
                      </Link>
                    </Tooltip>
                    <Tooltip label="Codebase">
                      <Link
                        target="_blank"
  rel="noopener noreferrer"
                        href="https://github.com/Hemant142/honest-wing-5796"
                        className="project-github-link"
                      >
                        <BiLogoGithub className="icon" />
                      </Link>
                    </Tooltip>
                  </Flex>
                </Box>
              </Flex>
              <Heading
                textAlign={"left"}
                size={"md"}
                mt="10px"
                className="project-title"
                fontFamily="initial"
              >
                <span style={{ color: darkMode ? "white" : "black" }}>
                  Sa Re Ga Ma
                </span>
              </Heading>
              <Text
                className="project-description"
                textAlign={"left"}
                mt="10px"
                fontFamily="cursive"
              >
                <span style={{ color: darkMode ? "white" : "#788097" }}>
                  Welcome to SA RE GA MA, your ultimate destination for all
                  things music. Whether you're a passionate musician, a
                  dedicated music enthusiast, or someone just looking to explore
                  the world of melodies, SA RE GA MA is your gateway to a
                  harmonious journey like no other.
                </span>
              </Text>

              <Box w={"100%"} mt="30px" className="project-tech-stack">
                <Text textAlign={"left"} fontSize="sm">
                  <span style={{ color: "#FCA61F", fontWeight: "bold" }}>
                    Tech-Stack :{" "}
                  </span>
                  <span style={{ color: darkMode ? "white" : "#788097" }}>
                    HTML5 | CSS3 | JavaScript | React | Redux | Chakra UI | Node
                    Js | Express JS | MongoDB | Mongoose | Json
                  </span>
                </Text>
              </Box>
            </Box>

            <Box
              w={{
                base: "100%",
                sm: "100%",
                md: "100%",
                lg: "100%",
                xl: "100%",
                "2xl": "100%",
              }}
              boxSizing="border-box"
            >
              <Image w="100%" src={"https://i.postimg.cc/VN6zJXCY/Songs.png"} />
            </Box>
          </Flex>
        </Box>
        {/* <================================Project -2======================================> */}
        <Box
          id="project-sec"
          data-aos="fade-right"
          boxSize={"border-box"}
          borderRadius={"10px"}
          p="20px"
          w="80%"
          m="40px auto"
          // className="project-card"
          className={`project-card ${darkMode ? "" : "dark-mode"}`}
        >
          <Flex
            gap={"30px"}
            justifyContent={"space-evenly"}
            direction={{
              base: "column-reverse",
              sm: "column-reverse",
              md: "column-reverse",
              lg: "row",
              xl: "row",
              "2xl": "row",
            }}
          >
            <Box
              w={{
                base: "100%",
                sm: "100%",
                md: "100%",
                lg: "100%",
                xl: "100%",
                "2xl": "100%",
              }}
              boxSizing="border-box"
            >
              <Flex justifyContent={"space-between"}>
                <PiSuitcaseSimpleDuotone
                  style={{ color: "#FCA61F", fontSize: "35px" }}
                />
                <Box>
                  <Flex gap={5}>
                    <Tooltip label="Live">
                      <Link
                        href="https://precious-and-charms.vercel.app/"
                        className="project-deployed-link"
                          target="_blank"
  rel="noopener noreferrer"
  isExternal
                      >
                        {" "}
                        <MdOutlinePlayCircle className="icon" />
                      </Link>
                    </Tooltip>
                    <Tooltip label="Codebase">
                      <Link
                        href="https://github.com/Hemant142/adaptable-oven-8035"
                        className="project-github-link"
                          target="_blank"
  rel="noopener noreferrer"
  isExternal
                      >
                        <BiLogoGithub className="icon" />
                      </Link>
                    </Tooltip>
                  </Flex>
                </Box>
              </Flex>
              <Heading
                textAlign={"left"}
                size={"md"}
                mt="10px"
                className="project-title"
                fontFamily="initial"
              >
                <span style={{ color: darkMode ? "white" : "black" }}>
                  PRECIOUS & CHARMS
                </span>
              </Heading>
              <Text
                className="project-description"
                textAlign={"left"}
                mt="10px"
                fontFamily="cursive"
              >
                <span style={{ color: darkMode ? "white" : "#788097" }}>
                  The objective of a PRECIOUS & CHARMS website is to create a
                  positive and engaging experience for potential customers that
                  will ultimately lead to increased sales and customer loyalty.
                </span>
              </Text>

              <Box w={"100%"} mt="30px" className="project-tech-stack">
                <Text textAlign={"left"} fontSize="sm">
                  <span style={{ color: "#FCA61F", fontWeight: "bold" }}>
                    Tech-Stack :{" "}
                  </span>
                  <span style={{ color: darkMode ? "white" : "#788097" }}>
                    HTML5 | CSS3 | JavaScript | React | Redux | Chakra UI |
                    TypeScript | Json
                  </span>
                </Text>
              </Box>
            </Box>

            <Box
              w={{
                base: "100%",
                sm: "100%",
                md: "100%",
                lg: "100%",
                xl: "100%",
                "2xl": "100%",
              }}
              boxSizing="border-box"
            >
              <Image w="100%" src={"https://i.postimg.cc/hPz2yQTD/Home.jpg"} />
            </Box>
          </Flex>
        </Box>

        {/* <================================Project -3======================================> */}
        <Box
          id="project-sec"
          data-aos="fade-right"
          boxSize={"border-box"}
          borderRadius={"10px"}
          p="20px"
          w="80%"
          m="40px auto"
          // className="project-card"
          className={`project-card ${darkMode ? "" : "dark-mode"}`}
        >
          <Flex
            gap={"30px"}
            justifyContent={"space-evenly"}
            direction={{
              base: "column-reverse",
              sm: "column-reverse",
              md: "column-reverse",
              lg: "row",
              xl: "row",
              "2xl": "row",
            }}
          >
            <Box
              w={{
                base: "100%",
                sm: "100%",
                md: "100%",
                lg: "100%",
                xl: "100%",
                "2xl": "100%",
              }}
              boxSizing="border-box"
            >
              <Flex justifyContent={"space-between"}>
                <PiSuitcaseSimpleDuotone
                  style={{ color: "#FCA61F", fontSize: "35px" }}
                />
                <Box>
                  <Flex gap={5}>
                    <Tooltip label="Live">
                      <Link
                        href="https://express-electronics-eta.vercel.app/"
                        className="project-deployed-link"
                          target="_blank"
  rel="noopener noreferrer"
  isExternal
                      >
                        {" "}
                        <MdOutlinePlayCircle className="icon" />
                      </Link>
                    </Tooltip>
                    <Tooltip label="Codebase">
                      <Link
                        href="https://github.com/Hemant142/Electronics-Product"
                        className="project-github-link"
                          target="_blank"
  rel="noopener noreferrer"
  isExternal
                      >
                        <BiLogoGithub className="icon" />
                      </Link>
                    </Tooltip>
                  </Flex>
                </Box>
              </Flex>
              <Heading
                textAlign={"left"}
                size={"md"}
                mt="10px"
                className="project-title"
                fontFamily="initial"
              >
                <span style={{ color: darkMode ? "white" : "black" }}>
                  Express-Electronics
                </span>
              </Heading>
              <span style={{ color: darkMode ? "white" : "#788097" }}>
                <Text
                  className="project-description"
                  textAlign={"left"}
                  mt="10px"
                  fontFamily="cursive"
                >
                  Welcome to Express-Electronics! This application aims to
                  revolutionize online electronic shopping, built using React
                  and Redux to provide users with a seamless shopping experience
                  for electronic items. With a user-friendly interface, user and
                  admin authentication, and various features. You can read on to
                  learn more about its components, features, and how to get
                  started.
                </Text>
              </span>

              <Box w={"100%"} mt="30px" className="project-tech-stack">
                <Text textAlign={"left"} fontSize="sm">
                  <span style={{ color: "#FCA61F", fontWeight: "bold" }}>
                    Tech-Stack :{" "}
                  </span>
                  <span style={{ color: darkMode ? "white" : "#788097" }}>
                    HTML5 | CSS3 | JavaScript | React | Redux |Chakra UI | Json Server
                  </span>
                </Text>
              </Box>
            </Box>

            <Box
              w={{
                base: "100%",
                sm: "100%",
                md: "100%",
                lg: "100%",
                xl: "100%",
                "2xl": "100%",
              }}
              boxSizing="border-box"
            >
              <Image
                w="100%"
                src={"https://i.postimg.cc/MTwD4gtb/HomePage.png"}
              />
            </Box>
          </Flex>
        </Box>

        {/* <================================Project -4======================================> */}
        <Box
          id="project-sec"
          data-aos="fade-right"
          boxSize={"border-box"}
          borderRadius={"10px"}
          p="20px"
          w="80%"
          m="40px auto"
          // className="project-card"
          className={`project-card ${darkMode ? "" : "dark-mode"}`}
        >
          <Flex
            gap={"30px"}
            justifyContent={"space-evenly"}
            direction={{
              base: "column-reverse",
              sm: "column-reverse",
              md: "column-reverse",
              lg: "row",
              xl: "row",
              "2xl": "row",
            }}
          >
            <Box
              w={{
                base: "100%",
                sm: "100%",
                md: "100%",
                lg: "100%",
                xl: "100%",
                "2xl": "100%",
              }}
              boxSizing="border-box"
            >
              <Flex justifyContent={"space-between"}>
                <PiSuitcaseSimpleDuotone
                  style={{ color: "#FCA61F", fontSize: "35px" }}
                />
                <Box>
                  <Flex gap={5}>
                    <Tooltip label="Live">
                      <Link
                        href="https://kidslands.vercel.app/"
                        className="project-deployed-link"
                          target="_blank"
  rel="noopener noreferrer"
  isExternal
                      >
                        {" "}
                        <MdOutlinePlayCircle className="icon" />
                      </Link>
                    </Tooltip>
                    <Tooltip label="Codebase">
                      <Link
                        href="https://github.com/Hemant142/Kid-s-Land"
                        className="project-github-link"
                          target="_blank"
                          isExternal
  rel="noopener noreferrer"
                      >
                        <BiLogoGithub className="icon" />
                      </Link>
                    </Tooltip>
                  </Flex>
                </Box>
              </Flex>
              <Heading
                textAlign={"left"}
                size={"md"}
                mt="10px"
                className="project-title"
                fontFamily="initial"
              >
                <span style={{ color: darkMode ? "white" : "black" }}>
                  KIDSLAND
                </span>
              </Heading>
              <span style={{ color: darkMode ? "white" : "#788097" }}>
                <Text
                  className="project-description"
                  textAlign={"left"}
                  mt="10px"
                  fontFamily="cursive"
                >
                  KidsLand is a vibrant online platform tailored for kids of age
                  group 2-15 years.It offers a diverse array of interactive
                  courses designed to make learning a delightful and seamless
                  experience.Children can enroll to courses of their choice and
                  learn seamlessly.
                </Text>
              </span>

              <Box w={"100%"} mt="30px" className="project-tech-stack">
                <Text textAlign={"left"} fontSize="sm">
                  <span style={{ color: "#FCA61F", fontWeight: "bold" }}>
                    Tech-Stack :{" "}
                  </span>
                  <span style={{ color: darkMode ? "white" : "#788097" }}>
                    HTML5 | CSS3 | JavaScript | React | Chakra UI | Json Server
                  </span>
                </Text>
              </Box>
            </Box>

            <Box
              w={{
                base: "100%",
                sm: "100%",
                md: "100%",
                lg: "100%",
                xl: "100%",
                "2xl": "100%",
              }}
              boxSizing="border-box"
            >
              <Image w="100%" src={"https://i.postimg.cc/qMM7Xdjr/Home.png"} />
            </Box>
          </Flex>
        </Box>

        {/* <================================Project -5======================================> */}

        <Box
          id="project-sec"
          data-aos="fade-right"
          boxSize={"border-box"}
          borderRadius={"10px"}
          p="20px"
          w="80%"
          m="40px auto"
          // className="project-card"
          className={`project-card ${darkMode ? "" : "dark-mode"}`}
        >
          <Flex
            gap={"30px"}
            justifyContent={"space-evenly"}
            direction={{
              base: "column-reverse",
              sm: "column-reverse",
              md: "column-reverse",
              lg: "row",
              xl: "row",
              "2xl": "row",
            }}
          >
            <Box
              w={{
                base: "100%",
                sm: "100%",
                md: "100%",
                lg: "100%",
                xl: "100%",
                "2xl": "100%",
              }}
              boxSizing="border-box"
            >
              <Flex justifyContent={"space-between"}>
                <PiSuitcaseSimpleDuotone
                  style={{ color: "#FCA61F", fontSize: "35px" }}
                />
                <Box>
                  <Flex gap={5}>
                    <Tooltip label="Live">
                      <Link
                        href="https://phlox-ruby.vercel.app/"
                        className="project-deployed-link"
                          target="_blank"
  rel="noopener noreferrer"
  isExternal
                      >
                        {" "}
                        <MdOutlinePlayCircle className="icon" />
                      </Link>
                    </Tooltip>
                    <Tooltip label="Codebase">
                      <Link
                        href="https://github.com/Hemant142/striped-substance-4459"
                        className="project-github-link"
                          target="_blank"
  rel="noopener noreferrer"
  isExternal
                      >
                        <BiLogoGithub className="icon" />
                      </Link>
                    </Tooltip>
                  </Flex>
                </Box>
              </Flex>
              <Heading
                textAlign={"left"}
                size={"md"}
                mt="10px"
                className="project-title"
                fontFamily="initial"
              >
                <span style={{ color: darkMode ? "white" : "black" }}>
                  PHLOX
                </span>
              </Heading>
              <span style={{ color: darkMode ? "white" : "#788097" }}>
                <Text
                  className="project-description"
                  textAlign={"left"}
                  mt="10px"
                  fontFamily="cursive"
                >
                  The objective of a PHLOX website is to create a positive and
                  engaging experience for potential customers that will
                  ultimately lead to increased sales and customer loyalty.
                </Text>
                <Text fontFamily="cursive" textAlign={"left"}>
                  Built Landing Page with carousal{" "}
                </Text>
                <Text fontFamily="cursive" textAlign={"left"}>
                  Built Footer Part{" "}
                </Text>
                <Text fontFamily="cursive" textAlign={"left"}>
                  Developed the product page
                </Text>
                <Text fontFamily="cursive" textAlign={"left"}>
                  Added add to cart functionality
                </Text>
              </span>

              <Box w={"100%"} mt="30px" className="project-tech-stack">
                <Text textAlign={"left"} fontSize="sm">
                  <span style={{ color: "#FCA61F", fontWeight: "bold" }}>
                    Tech-Stack :{" "}
                  </span>
                  <span style={{ color: darkMode ? "white" : "#788097" }}>
                    HTML5 | CSS3 | JavaScript | React | Redux | Chakra UI | Json
                  </span>
                </Text>
              </Box>
            </Box>

            <Box
              w={{
                base: "100%",
                sm: "100%",
                md: "100%",
                lg: "100%",
                xl: "100%",
                "2xl": "100%",
              }}
              boxSizing="border-box"
            >
              <Image
                w="100%"
                src={"https://i.postimg.cc/vBqq0hGz/Homepage2.png"}
              />
            </Box>
          </Flex>
        </Box>
        {/* <================================Project -6======================================> */}
        <Box
          id="project-sec"
          data-aos="fade-right"
          boxSize={"border-box"}
          borderRadius={"10px"}
          p="20px"
          w="80%"
          m="40px auto"
          // className="project-card"
          className={`project-card ${darkMode ? "" : "dark-mode"}`}
        >
          <Flex
            gap={"30px"}
            justifyContent={"space-evenly"}
            direction={{
              base: "column-reverse",
              sm: "column-reverse",
              md: "column-reverse",
              lg: "row",
              xl: "row",
              "2xl": "row",
            }}
          >
            <Box
              w={{
                base: "100%",
                sm: "100%",
                md: "100%",
                lg: "100%",
                xl: "100%",
                "2xl": "100%",
              }}
              boxSizing="border-box"
            >
              <Flex justifyContent={"space-between"}>
                <PiSuitcaseSimpleDuotone
                  style={{ color: "#FCA61F", fontSize: "35px" }}
                />
                <Box>
                  <Flex gap={5}>
                    <Tooltip label="Live">
                      <Link
                        href="https://playful-caramel-2a397b.netlify.app/html/product.html"
                        className="project-deployed-link"
                        isExternal
  
                      >
                        {" "}
                        <MdOutlinePlayCircle className="icon" />
                      </Link>
                    </Tooltip>
                    <Tooltip label="Codebase">
                      <Link
                        href="https://github.com/PallvaKuarweb23/radioactive-lip-3578-"
                        className="project-github-link"
                          target="_blank"
  rel="noopener noreferrer"
  isExternal
                      >
                        <BiLogoGithub className="icon" />
                      </Link>
                    </Tooltip>
                  </Flex>
                </Box>
              </Flex>
              <Heading
                textAlign={"left"}
                size={"md"}
                mt="10px"
                className="project-title"
                fontFamily="initial"
              >
                <span style={{ color: darkMode ? "white" : "black" }}>
                  THE STYLISTA
                </span>
              </Heading>
              <Text
                className="project-description"
                textAlign={"left"}
                mt="10px"
                fontFamily="cursive"
              >
                <span style={{ color: darkMode ? "white" : "#788097" }}>
                  The objective of a THE STYLISTA website is to create a
                  positive and engaging experience for potential customers that
                  will ultimately lead to increased sales and customer
                  loyalty.It is a closthing website
                </span>
              </Text>

              <Box w={"100%"} mt="30px" className="project-tech-stack">
                <Text textAlign={"left"} fontSize="sm">
                  <span style={{ color: "#FCA61F", fontWeight: "bold" }}>
                    Tech-Stack :{" "}
                  </span>
                  <span style={{ color: darkMode ? "white" : "#788097" }}>
                    HTML | CSS | JavaScript | Json
                  </span>
                </Text>
              </Box>
            </Box>

            <Box
              w={{
                base: "100%",
                sm: "100%",
                md: "100%",
                lg: "100%",
                xl: "100%",
                "2xl": "100%",
              }}
              boxSizing="border-box"
            >
              <Image
                w="100%"

                src={"https://i.postimg.cc/bJKfXJP0/Stylista.png"}
              />
            </Box>
          </Flex>
        </Box>
      </Grid>
    </Box>
  );
};

// export default Projects;
